import { render, staticRenderFns } from "./LivestreamCommentInput.vue?vue&type=template&id=579243ce&"
import script from "./LivestreamCommentInput.vue?vue&type=script&lang=js&"
export * from "./LivestreamCommentInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports